"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BundleTokenSchema = exports.BundleTokenBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
exports.BundleTokenBaseSchema = zod_1.z.object({
    sstId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    bundleId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    isActive: zod_1.z.date().nullable().default(null),
});
exports.BundleTokenSchema = exports.BundleTokenBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=BundleToken.js.map